import { IProcessXetHocVuRequest } from "../../model/request/xet-hoc-vu/IProcessXetHocVuRequest";
import { apiClient } from "../apiClient";

const XET_HOC_VU_ENDPOINT = "xet-hoc-vu";
export const xetHocVuApi = {
    SelectByDotXet: (id: number) => apiClient.get(`${XET_HOC_VU_ENDPOINT}/dot-xet/${id}/ket-qua`),
    XetHocVu: (request: IProcessXetHocVuRequest) => apiClient.post(`${XET_HOC_VU_ENDPOINT}/dot-xet/${request.id_dot_xet}/xet?process_id=${request.process_id}`),
    SendCanhBaoEmail: (id_dot_xet: number, ids: string[]) => apiClient.post(`${XET_HOC_VU_ENDPOINT}/gui-email-canh-bao`, { id_dot_xet, ids }),
}
